import React from "react";
import { useLang } from "@/contexts/LanguageContext";

const Badge = ({ result, tWin, tLoss }) => {
  const win = result === "WIN";
  return (
    <span
      data-testid={`res-${result}`}
      className={`inline-flex items-center justify-center px-2 py-0.5 text-[10px] font-bold tracking-[0.15em] ${
        win
          ? "bg-[#10B981]/15 text-[#10B981] border border-[#10B981]/30"
          : "bg-[var(--hk-red)]/15 text-[var(--hk-red)] border border-[var(--hk-red)]/40"
      }`}
    >
      {win ? tWin : tLoss}
    </span>
  );
};

const Leg = ({ leg, t }) => (
  <div className="flex items-center justify-between gap-3 py-1.5">
    <div className="min-w-0">
      <div className="text-sm text-white truncate">
        {leg.home} <span className="text-white/40">vs</span> {leg.away}
      </div>
      <div className="text-[11px] text-white/50 mt-0.5">
        {leg.pick} <span className="font-mono text-white/70">@ {leg.odds}</span>
      </div>
    </div>
    <div className="flex items-center gap-3 shrink-0">
      <span className="font-mono text-sm text-white/80">{leg.ft}</span>
      <Badge result={leg.result} tWin={t.archive.win} tLoss={t.archive.loss} />
    </div>
  </div>
);

// A double-bet row: date on the left, both matches stacked in the same row
const ArchiveRow = ({ row }) => {
  const { t } = useLang();
  return (
    <div
      data-testid={`arch-row-${row.iso}`}
      className="tbl-row grid grid-cols-1 md:grid-cols-12 gap-2 md:gap-4 border-b border-white/8 px-4 md:px-6 py-4"
    >
      <div className="md:col-span-2 flex md:block items-center gap-2">
        <span className="font-mono text-sm text-[var(--hk-red)] font-semibold">{row.date}</span>
        <span className="text-[9px] tracking-[0.25em] text-white/40 uppercase md:mt-1 md:block">Double</span>
      </div>
      <div className="md:col-span-10 divide-y divide-white/5">
        {row.no_double ? (
          <div data-testid="no-double" className="flex items-center py-1.5">
            <span className="inline-flex items-center px-3 py-1.5 text-[10px] md:text-[11px] font-bold tracking-[0.25em] uppercase border border-white/15 bg-white/[0.04] text-white/60">
              {t.archive.no_double}
            </span>
          </div>
        ) : (
          row.legs.map((leg, i) => <Leg key={i} leg={leg} t={t} />)
        )}
      </div>
    </div>
  );
};

export default ArchiveRow;
